/**
 * Permissões de ação derivadas das roles de GET /api/auth/me.
 * As roles continuam vindo do backend; aqui só se lê o que o usuário tem.
 * O backend é a autoridade: mesmo com a ação visível, trate o 403.
 */
export const OWNER_ROLE = "ROLE_OWNER";
export const ADMIN_ROLE = "ROLE_ADMIN";

export const normalizeRole = (role) => {
  const name = String(role || "")
    .trim()
    .toUpperCase();
  if (!name) return "";
  return name.startsWith("ROLE_") ? name : `ROLE_${name}`;
};

export const hasRole = (user, role) => {
  const target = normalizeRole(role);
  const roles = Array.isArray(user?.roles)
    ? user.roles
    : user?.role
      ? [user.role]
      : [];
  return roles.some((r) => normalizeRole(r) === target);
};

/** ROLE_OWNER: visão global, único que cria empresas e altera menus/perfis */
export const isOwner = (user) => hasRole(user, OWNER_ROLE);

/** ROLE_ADMIN ou ROLE_OWNER: CRUD administrativo da empresa */
export const isAdmin = (user) => isOwner(user) || hasRole(user, ADMIN_ROLE);

/** Owner sem empresa no token: escolhe a empresa via X-Company-Code */
export const isGlobalOwner = (user) => isOwner(user) && !user?.company_code;

/** Qualquer usuário logado no painel (não guest) */
export const isPanelUser = (user) => !!user && !hasRole(user, "ROLE_GUEST");
